<div class="form-card">
  <mat-card appearance="outlined">
    <app-logo></app-logo>

    @if(!_paramCursoData.cusroCancelado){

      <mat-card-header>
        <div class="sucesso">
          <h3 class="sucesso-title"><mat-icon>check_circle</mat-icon> {{ "conclusao.concluia_com_sucesso" | translate }}</h3>
          <p>
            <b>{{ nome_aluno }}</b>{{ "conclusao.msg_sua_inscricao_no_curso" | translate }} <b>{{ nome_curso }}</b> {{ "conclusao.msg_registrada_em" | translate }} <b>{{ data_inclusao | date:'dd/MM/yyyy HH:mm':'UTC':'pt-BR' }}</b>.
          </p>
          <p class="posicao-inscrito">{{ "conclusao.voce_e_o_escrito_numero" | translate:{posicao: posicao} }}</p>
        </div>
      </mat-card-header>
    }

    <router-outlet></router-outlet>

  </mat-card>
</div>

@if(loading){

  <div class="loader-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
